import { defineMessage } from 'react-intl';

const cancelMessage = defineMessage({
    defaultMessage: 'Cancel',
    id: 'SNyjv/',
    description: 'Cancel choosing date'
});
const applyMessage = defineMessage({
    defaultMessage: 'Apply',
    id: 'qj3Cr1',
    description: 'Apply date'
});

export { applyMessage, cancelMessage };
//# sourceMappingURL=messages.esm.js.map
